"use strict";
// Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var ClientMetricReportDirection_1 = require("../clientmetricreport/ClientMetricReportDirection");
var ClientMetricReportMediaType_1 = require("../clientmetricreport/ClientMetricReportMediaType");
var ClientVideoStreamReceivingReport_1 = require("../clientmetricreport/ClientVideoStreamReceivingReport");
var ReconnectionHealthPolicy_1 = require("../connectionhealthpolicy/ReconnectionHealthPolicy");
var UnusableAudioWarningConnectionHealthPolicy_1 = require("../connectionhealthpolicy/UnusableAudioWarningConnectionHealthPolicy");
var Maybe_1 = require("../maybe/Maybe");
var MeetingSessionStatus_1 = require("../meetingsession/MeetingSessionStatus");
var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");
var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");
var AudioLogEvent_1 = require("../statscollector/AudioLogEvent");
var VideoLogEvent_1 = require("../statscollector/VideoLogEvent");
var BaseTask_1 = require("./BaseTask");
/*
 * [[MonitorTask]] monitors connections using SignalingAndMetricsConnectionMonitor.
 */
var MonitorTask = /** @class */ (function (_super) {
    __extends(MonitorTask, _super);
    function MonitorTask(context, connectionHealthPolicyConfiguration, initialConnectionHealthData) {
        var _this = _super.call(this, context.logger) || this;
        _this.context = context;
        _this.initialConnectionHealthData = initialConnectionHealthData;
        _this.taskName = 'MonitorTask';
        _this.prevSignalStrength = 1;
        _this.currentVideoDownlinkBandwidthEstimationKbps = 10000;
        _this.currentAvailableStreamAvgBitrates = null;
        _this.checkAndSendWeakSignalEvent = function (signalStrength) {
            var isCurrentSignalBad = signalStrength < 1;
            var isPrevSignalBad = _this.prevSignalStrength < 1;
            var signalStrengthEventType = isCurrentSignalBad
                ? !isPrevSignalBad
                    ? AudioLogEvent_1.default.RedmicStartLoss
                    : null
                : isPrevSignalBad
                    ? AudioLogEvent_1.default.RedmicEndLoss
                    : null;
            if (signalStrengthEventType) {
                _this.context.statsCollector.logAudioEvent(signalStrengthEventType);
            }
            _this.prevSignalStrength = signalStrength;
        };
        _this.realtimeFatalErrorCallback = function (error) {
            _this.logger.error("realtime error: " + error + ": " + error.stack);
            _this.context.audioVideoController.handleMeetingSessionStatus(new MeetingSessionStatus_1.default(MeetingSessionStatusCode_1.default.RealtimeApiFailed));
        };
        _this.reconnectionHealthPolicy = new ReconnectionHealthPolicy_1.default(context.logger, __assign({}, connectionHealthPolicyConfiguration), _this.initialConnectionHealthData.clone());
        _this.unusableAudioWarningHealthPolicy = new UnusableAudioWarningConnectionHealthPolicy_1.default(__assign({}, connectionHealthPolicyConfiguration), _this.initialConnectionHealthData.clone());
        return _this;
    }
    MonitorTask.prototype.removeObserver = function () {
        this.context.audioVideoController.removeObserver(this);
        this.context.realtimeController.realtimeUnsubscribeToFatalError(this.realtimeFatalErrorCallback);
        this.context.realtimeController.realtimeUnsubscribeToLocalSignalStrengthChange(this.checkAndSendWeakSignalEvent);
        this.context.signalingClient.removeObserver(this);
    };
    MonitorTask.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.context.removableObservers.push(this);
                this.context.audioVideoController.addObserver(this);
                this.context.realtimeController.realtimeSubscribeToFatalError(this.realtimeFatalErrorCallback);
                this.context.realtimeController.realtimeSubscribeToLocalSignalStrengthChange(this.checkAndSendWeakSignalEvent);
                this.context.connectionMonitor.start();
                this.context.statsCollector.start(this.context.signalingClient, this.context.videoStreamIndex);
                this.context.signalingClient.registerObserver(this);
                return [2 /*return*/];
            });
        });
    };
    MonitorTask.prototype.videoSendHealthDidChange = function (bitrateKbps, packetsPerSecond) {
        if (this.context.videoInputAttachedTimestampMs === 0 ||
            !this.context.videoTileController.hasStartedLocalVideoTile() ||
            !this.context.lastKnownVideoAvailability.canStartLocalVideo) {
            return;
        }
        var tracks = this.context.activeVideoInput !== null ? this.context.activeVideoInput.getTracks() : null;
        if (!tracks || !tracks[0]) {
            return;
        }
        var durationMs = Date.now() - this.context.videoInputAttachedTimestampMs;
        if (packetsPerSecond > 0 || bitrateKbps > 0) {
            this.context.statsCollector.logVideoEvent(VideoLogEvent_1.default.SendingSuccess, this.context.videoDeviceInformation);
            this.context.statsCollector.logLatency('video_start_sending', durationMs, this.context.videoDeviceInformation);
            this.context.videoInputAttachedTimestampMs = 0;
        }
        else if (durationMs > MonitorTask.DEFAULT_TIMEOUT_FOR_START_SENDING_VIDEO_MS) {
            this.context.statsCollector.logVideoEvent(VideoLogEvent_1.default.SendingFailed, this.context.videoDeviceInformation);
            this.context.videoInputAttachedTimestampMs = 0;
        }
    };
    MonitorTask.prototype.videoReceiveBandwidthDidChange = function (newBandwidthKbps, oldBandwidthKbps) {
        if (this.context.videoDownlinkBandwidthPolicy) {
            this.logger.debug(function () {
                return "receiving bandwidth changed from prev=" + oldBandwidthKbps + " Kbps to curr=" + newBandwidthKbps + " Kbps";
            });
            this.currentVideoDownlinkBandwidthEstimationKbps = newBandwidthKbps;
            this.context.videoDownlinkBandwidthPolicy.updateAvailableBandwidth(newBandwidthKbps);
            var resubscribeForDownlink = this.context.videoDownlinkBandwidthPolicy.wantsResubscribe();
            if (resubscribeForDownlink) {
                this.context.videosToReceive = this.context.videoDownlinkBandwidthPolicy.chooseSubscriptions();
                this.logger.info("trigger resubscribe for down=" + resubscribeForDownlink + "; videosToReceive=[" + this.context.videosToReceive.array() + "]");
                this.context.audioVideoController.update();
            }
        }
    };
    MonitorTask.prototype.metricsDidReceive = function (clientMetricReport) {
        var e_1, _a;
        if (!this.currentAvailableStreamAvgBitrates) {
            return;
        }
        var defaultClientMetricReport = clientMetricReport;
        if (!defaultClientMetricReport) {
            return;
        }
        var streamMetricReport = defaultClientMetricReport.streamMetricReports;
        if (!streamMetricReport) {
            return;
        }
        var downlinkVideoStream = new Map();
        var videoReceivingBitrateMap = new Map();
        // TODO: move those logic to stats collector.
        for (var ssrc in streamMetricReport) {
            if (streamMetricReport[ssrc].mediaType === ClientMetricReportMediaType_1.default.VIDEO &&
                streamMetricReport[ssrc].direction === ClientMetricReportDirection_1.default.DOWNSTREAM) {
                downlinkVideoStream.set(streamMetricReport[ssrc].streamId, streamMetricReport[ssrc]);
            }
        }
        var fireCallback = false;
        try {
            for (var _b = __values(this.currentAvailableStreamAvgBitrates.bitrates), _c = _b.next(); !_c.done; _c = _b.next()) {
                var bitrate = _c.value;
                if (downlinkVideoStream.has(bitrate.sourceStreamId)) {
                    var report = downlinkVideoStream.get(bitrate.sourceStreamId);
                    var attendeeId = this.context.videoStreamIndex.attendeeIdForStreamId(bitrate.sourceStreamId);
                    if (!attendeeId) {
                        continue;
                    }
                    var newReport = new ClientVideoStreamReceivingReport_1.default();
                    var prevBytesReceived = report.previousMetrics['bytesReceived'];
                    var currBytesReceived = report.currentMetrics['bytesReceived'];
                    if (!prevBytesReceived || !currBytesReceived) {
                        continue;
                    }
                    var receivedBitrate = ((currBytesReceived - prevBytesReceived) * 8) / 1000;
                    newReport.expectedAverageBitrateKbps = bitrate.avgBitrateBps / 1000;
                    newReport.receivedAverageBitrateKbps = receivedBitrate;
                    newReport.attendeeId = attendeeId;
                    if (receivedBitrate <
                        (bitrate.avgBitrateBps / 1000) * MonitorTask.DEFAULT_DOWNLINK_CALLRATE_UNDERSHOOT_FACTOR) {
                        fireCallback = true;
                    }
                    videoReceivingBitrateMap.set(attendeeId, newReport);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (fireCallback) {
            this.logger.debug(function () {
                return "Downlink video streams are not receiving enough data";
            });
            this.context.audioVideoController.forEachObserver(function (observer) {
                Maybe_1.default.of(observer.videoNotReceivingEnoughData).map(function (f) {
                    return f.bind(observer)(Array.from(videoReceivingBitrateMap.values()));
                });
            });
        }
    };
    MonitorTask.prototype.connectionHealthDidChange = function (connectionHealthData) {
        if (connectionHealthData.consecutiveMissedPongs === 0) {
            if (this.context.reconnectController) {
                this.context.reconnectController.setLastActiveTimestampMs(Date.now());
            }
        }
        this.reconnectionHealthPolicy.update(connectionHealthData);
        var reconnectionValue = this.reconnectionHealthPolicy.healthIfChanged();
        if (reconnectionValue !== null) {
            this.logger.info("reconnection health is now: " + reconnectionValue);
            if (reconnectionValue === 0) {
                this.context.audioVideoController.handleMeetingSessionStatus(new MeetingSessionStatus_1.default(MeetingSessionStatusCode_1.default.ConnectionHealthReconnect));
            }
        }
        this.unusableAudioWarningHealthPolicy.update(connectionHealthData);
        var unusableAudioWarningValue = this.unusableAudioWarningHealthPolicy.healthIfChanged();
        if (unusableAudioWarningValue !== null) {
            this.logger.info("unusable audio warning is now: " + unusableAudioWarningValue);
            if (unusableAudioWarningValue === 0) {
                if (this.context.videoTileController.haveVideoTilesWithStreams()) {
                    this.context.audioVideoController.forEachObserver(function (observer) {
                        Maybe_1.default.of(observer.connectionDidSuggestStopVideo).map(function (f) { return f.bind(observer)(); });
                    });
                }
                else {
                    this.context.audioVideoController.forEachObserver(function (observer) {
                        Maybe_1.default.of(observer.connectionDidBecomePoor).map(function (f) { return f.bind(observer)(); });
                    });
                }
            }
        }
    };
    MonitorTask.prototype.handleSignalingClientEvent = function (event) {
        var e_2, _a;
        var _this = this;
        if (event.type !== SignalingClientEventType_1.default.ReceivedSignalFrame) {
            return;
        }
        if (!!event.message.bitrates) {
            var videoSubscription = this.context.videoSubscriptions || [];
            var requiredBandwidthKbps_1 = 0;
            this.currentAvailableStreamAvgBitrates = event.message.bitrates;
            try {
                for (var _b = __values(event.message.bitrates.bitrates), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var bitrate = _c.value;
                    if (videoSubscription.indexOf(bitrate.sourceStreamId) !== -1) {
                        requiredBandwidthKbps_1 += bitrate.avgBitrateBps;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            requiredBandwidthKbps_1 /= 1000;
            if (this.currentVideoDownlinkBandwidthEstimationKbps *
                MonitorTask.DEFAULT_DOWNLINK_CALLRATE_OVERSHOOT_FACTOR <
                requiredBandwidthKbps_1) {
                this.logger.debug(function () {
                    return "Downlink bandwidth pressure is high: estimated bandwidth " + _this.currentVideoDownlinkBandwidthEstimationKbps + "Kbps, required bandwidth " + requiredBandwidthKbps_1 + "Kbps";
                });
                this.context.audioVideoController.forEachObserver(function (observer) {
                    Maybe_1.default.of(observer.estimatedDownlinkBandwidthLessThanRequired).map(function (f) {
                        return f.bind(observer)(_this.currentVideoDownlinkBandwidthEstimationKbps, requiredBandwidthKbps_1);
                    });
                });
            }
        }
        var status = MeetingSessionStatus_1.default.fromSignalFrame(event.message);
        if (status.statusCode() !== MeetingSessionStatusCode_1.default.OK) {
            this.context.audioVideoController.handleMeetingSessionStatus(status);
        }
    };
    MonitorTask.DEFAULT_TIMEOUT_FOR_START_SENDING_VIDEO_MS = 30000;
    MonitorTask.DEFAULT_DOWNLINK_CALLRATE_OVERSHOOT_FACTOR = 1.5;
    MonitorTask.DEFAULT_DOWNLINK_CALLRATE_UNDERSHOOT_FACTOR = 0.5;
    return MonitorTask;
}(BaseTask_1.default));
exports.default = MonitorTask;
//# sourceMappingURL=MonitorTask.js.map